import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19bd1de2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown min-w-max flex flex-wrap content-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Toggle", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-4 bg-gray-50 rounded max-w-max" }, "Test Content", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _renderSlot(_ctx.$slots, "toggler", {}, () => [
        _hoisted_2
      ], true)
    ]),
    _createVNode(_Transition, {
      name: "fade",
      appear: "",
      onClick: _ctx.optionSelected
    }, {
      default: _withCtx(() => [
        (_ctx.active)
          ? _renderSlot(_ctx.$slots, "content", { key: 0 }, () => [
              _hoisted_3
            ], true)
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["onClick"])
  ])), [
    [_directive_click_away, _ctx.close]
  ])
}